module.exports = __webpack_public_path__ + "static/media/slim-branco.164c0220.webp";